<div *ngIf="activeProject; else noProject" class="tsn-wrap">

  <!-- Master: Liste der Zeitschaltuhren -->
  <aside class="tsn-master">
    <div class="tsn-master-head">
      <h5 class="m-0">Zeitschaltuhren</h5>
      <button *canAccess="[1]" class="btn btn-sm btn-outline-danger rounded-0" (click)="onAddTimer()">+ Neu</button>
    </div>
    <p *ngIf="timerSwitches.length === 0" class="text-secondary small mt-2">
      Noch keine Zeitschaltuhr angelegt.
    </p>
    <button *ngFor="let ts of timerSwitches" type="button" class="tsn-card"
      [class.active]="ts === selectedTimer" (click)="selectTimer(ts)">
      <div class="tsn-card-row">
        <span class="tsn-card-name">{{ ts.name }}</span>
        <span class="tsn-pill" [class.on]="ts.enabled" [class.off]="!ts.enabled">
          {{ ts.enabled ? 'Aktiv' : 'Inaktiv' }}
        </span>
      </div>
      <div class="tsn-card-meta mono">
        {{ ts.start | date: 'dd.MM.yyyy' }} – {{ ts.stop | date: 'dd.MM.yyyy' }}
      </div>
      <div class="tsn-card-meta">
        {{ (ts.aqTimers?.length || 0) + (ts.mqTimers?.length || 0) + (ts.blinkerTimers?.length || 0)
           + (ts.doTimers?.length || 0) + (ts.diTimers?.length || 0) }} Schaltpunkte
      </div>
    </button>
  </aside>

  <!-- Detail -->
  <section class="tsn-detail" *ngIf="selectedTimer; else noSelection">

    <!-- Kopf -->
    <div class="tsn-panel tsn-head">
      <div class="tsn-head-main">
        <div class="tsn-title">
          <h4 class="m-0">{{ selectedTimer.name }}</h4>
          <span class="tsn-pill" [class.on]="selectedTimer.enabled" [class.off]="!selectedTimer.enabled">
            {{ selectedTimer.enabled ? 'Aktiv' : 'Inaktiv' }}
          </span>
        </div>
        <div class="tsn-validity mono">
          Gültig {{ selectedTimer.start | date: 'dd.MM.yyyy' }} bis {{ selectedTimer.stop | date: 'dd.MM.yyyy' }}
        </div>
      </div>
      <div class="tsn-head-actions" *canAccess="[1]">
        <button class="btn btn-sm btn-outline-secondary rounded-0" (click)="onEditTimer(selectedTimer)">Bearbeiten</button>
        <button class="btn btn-sm btn-outline-secondary rounded-0" (click)="toggleEnabled(selectedTimer)">
          {{ selectedTimer.enabled ? 'Pausieren' : 'Aktivieren' }}
        </button>
        <button class="btn btn-sm btn-outline-danger rounded-0" (click)="onDeleteTimer(selectedTimer)">Löschen</button>
      </div>
    </div>

    <!-- Ergebnis-Zeitleiste -->
    <div class="tsn-panel">
      <div class="tsn-toolbar">
        <span class="tsn-toolbar-title">Ergebnis · was geschaltet wird</span>
        <div class="tsn-daterange">
          <button type="button" class="tsn-icon-btn" (click)="shiftWindow('prev')" title="Zeitraum zurück">‹</button>
          <span class="mono">{{ windowLabel }}</span>
          <button type="button" class="tsn-icon-btn" (click)="shiftWindow('next')" title="Zeitraum weiter">›</button>
          <select class="form-select form-select-sm rounded-0 tsn-days-select" [ngModel]="windowDays" (ngModelChange)="setWindowDays($event)">
            <option [ngValue]="1">1 Tag</option>
            <option [ngValue]="3">3 Tage</option>
            <option [ngValue]="7">7 Tage</option>
            <option [ngValue]="14">14 Tage</option>
          </select>
        </div>
        <span class="tsn-toolbar-spacer"></span>
        <button *canAccess="[1]" class="btn btn-sm btn-danger rounded-0" (click)="openEditor()">+ Schaltpunkt</button>
      </div>

      <div class="tsn-tl-scroll">
        <div class="tsn-tl">
          <div class="tsn-axis">
            <div></div>
            <div class="tsn-ticks">
              <span *ngFor="let t of dayTicks" class="tsn-tick" [style.left.%]="t.leftPct">{{ t.label }}</span>
            </div>
          </div>

          <div *ngIf="lanes.length === 0" class="tsn-empty">
            In diesem Zeitraum sind keine Schaltungen aktiv.
          </div>

          <div class="tsn-lane" *ngFor="let lane of lanes">
            <div class="tsn-lane-label">
              <span class="tsn-swatch" [style.background]="laneColor(lane.key)"></span>
              <div>{{ lane.label }}<small *ngIf="lane.sub">{{ lane.sub }}</small></div>
            </div>
            <div class="tsn-track" [style.background]="trackBackground">
              <div class="tsn-blk" [class.tsn-blk-onetime]="seg.oneTime" [class.tsn-blk-aq]="lane.key === 'aq'"
                *ngFor="let seg of lane.segments"
                [style.left]="segmentLeft(seg)" [style.width]="segmentWidth(seg)"
                [style.borderColor]="laneColor(lane.key)" [style.background]="segmentFill(lane, seg.sp)"
                (mouseenter)="onBlockEnter($event, lane, seg)" (mousemove)="movePreview($event)" (mouseleave)="hidePreview()">
                <img *ngIf="lane.key === 'aq' && stellbildPath(seg.sp) as path" [src]="path" class="tsn-stellbild"
                  [class.tsn-stellbild-off]="seg.sp.tlS_Function === 0" alt="Stellbild">
                <span class="tsn-blk-text tsn-blk-text-dark" *ngIf="lane.key === 'aq' && !stellbildPath(seg.sp)">{{ segmentLabel(lane, seg.sp) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p class="tsn-explain">
        Zusammengeführtes Ergebnis je Ausgang über den gewählten Zeitraum – wiederkehrende und einmalige
        Schaltungen kombiniert. Bei Überschneidung gewinnt der Schaltpunkt mit höherem Vorrang (siehe
        „Schaltpunkte"). Rand = Typ, Füllung = Zustand (MQ nach Verkehrsstufe grün→rot).
        <span class="tsn-legend-dash"></span> gestrichelter Rand = einmalige Schaltung.
      </p>
    </div>

    <!-- Schaltpunkte verwalten: Vorrang / bearbeiten / löschen -->
    <div class="tsn-panel tsn-manage" *ngIf="managedComponents.length > 0">
      <div class="tsn-manage-head">
        <h6 class="m-0">Schaltpunkte</h6>
        <span class="text-secondary small">Reihenfolge = Vorrang · oberster gewinnt bei Überschneidung</span>
      </div>
      <div class="tsn-manage-group" *ngFor="let c of managedComponents">
        <div class="tsn-manage-group-title"><span class="tsn-swatch" [style.background]="laneColor(c.key)"></span> {{ c.label }}</div>
        <div class="tsn-point" *ngFor="let sp of managedPoints(c.key); let i = index; let last = last">
          <span class="tsn-point-rank mono">{{ i + 1 }}</span>
          <img *ngIf="c.key === 'aq' && stellbildPath(sp) as path" [src]="path" class="tsn-point-thumb"
            [class.tsn-stellbild-off]="sp.tlS_Function === 0" alt="Stellbild">
          <span class="tsn-point-text">{{ pointSummary(c.key, sp) }}</span>
          <span class="tsn-point-actions" *canAccess="[1]">
            <button type="button" class="tsn-icon-btn" [disabled]="i === 0" (click)="movePoint(c.key, i, 'up')" title="Vorrang höher">↑</button>
            <button type="button" class="tsn-icon-btn" [disabled]="last" (click)="movePoint(c.key, i, 'down')" title="Vorrang niedriger">↓</button>
            <button type="button" class="tsn-icon-btn" (click)="editPoint(c.key, sp)" title="Bearbeiten">✎</button>
            <button type="button" class="tsn-icon-btn danger" (click)="deletePoint(c.key, sp)" title="Löschen">🗑</button>
          </span>
        </div>
      </div>
    </div>

    <!-- Editor: neuer Schaltpunkt -->
    <div class="tsn-panel tsn-editor" *ngIf="editorOpen">
      <div class="tsn-editor-head">
        <h6 class="m-0">{{ draft.id === undefined ? 'Neuer Schaltpunkt' : 'Schaltpunkt bearbeiten' }}</h6>
        <button type="button" class="btn btn-sm btn-link text-secondary p-0" (click)="closeEditor()">Schließen</button>
      </div>

      <div class="tsn-field">
        <label>Komponente</label>
        <div class="tsn-comppick">
          <button type="button" [class.active]="draft.component==='aq'" (click)="setDraftComponent('aq')"><span class="tsn-swatch" [style.background]="laneColor('aq')"></span> AQ</button>
          <button type="button" [class.active]="draft.component==='mq'" (click)="setDraftComponent('mq')"><span class="tsn-swatch" [style.background]="laneColor('mq')"></span> MQ</button>
          <button type="button" [class.active]="draft.component==='blinker'" (click)="setDraftComponent('blinker')"><span class="tsn-swatch" [style.background]="laneColor('blinker')"></span> Blinker</button>
          <button type="button" [class.active]="draft.component==='do'" (click)="setDraftComponent('do')"><span class="tsn-swatch" [style.background]="laneColor('do')"></span> DO</button>
          <button type="button" [class.active]="draft.component==='di'" (click)="setDraftComponent('di')"><span class="tsn-swatch" [style.background]="laneColor('di')"></span> DI</button>
        </div>
      </div>

      <div class="tsn-editor-grid">
        <!-- AQ -->
        <div class="tsn-field" *ngIf="draft.component==='aq'">
          <label>Stellbild</label>
          <div class="tsn-sb-selected">
            <img *ngIf="draftStellbildPath() as p" [src]="p" class="tsn-stellbild" alt="Stellbild">
            <span *ngIf="draft.tlS_Code !== undefined" class="mono">Stellcode {{ draft.tlS_Code }}</span>
            <span *ngIf="draft.tlS_Code === undefined" class="text-secondary small">kein Stellbild gewählt</span>
            <button type="button" class="btn btn-sm btn-outline-secondary rounded-0 ms-auto" (click)="sbPickerOpen = true">Wählen…</button>
          </div>
        </div>
        <div class="tsn-field" *ngIf="draft.component==='aq'">
          <label>Funktion</label>
          <select class="form-select form-select-sm rounded-0" [(ngModel)]="draft.tlS_Function">
            <option *ngFor="let f of functionOptions" [ngValue]="f.id">{{ f.name }}</option>
          </select>
        </div>
        <!-- MQ -->
        <div class="tsn-field" *ngIf="draft.component==='mq'">
          <label>Verkehrsstufe</label>
          <select class="form-select form-select-sm rounded-0" [(ngModel)]="draft.trafic">
            <option *ngFor="let v of verkehrsstufe" [ngValue]="v.id">{{ v.name }}</option>
          </select>
        </div>
        <div class="tsn-field" *ngIf="draft.component==='mq'">
          <label>Verkehrszustand</label>
          <select class="form-select form-select-sm rounded-0" [(ngModel)]="draft.vs">
            <option *ngFor="let v of verkehrszustand" [ngValue]="v.id">{{ v.name }}</option>
          </select>
        </div>

        <!-- DO / DI -->
        <div class="tsn-field" *ngIf="draft.component==='do' || draft.component==='di'">
          <label>Zustand</label>
          <select class="form-select form-select-sm rounded-0" [(ngModel)]="draft.state">
            <option [ngValue]="true">An</option>
            <option [ngValue]="false">Aus</option>
          </select>
        </div>

        <!-- Blinker -->
        <div class="tsn-field" *ngIf="draft.component==='blinker'">
          <label>Zustand</label>
          <select class="form-select form-select-sm rounded-0" [(ngModel)]="draft.tlS_Function">
            <option [ngValue]="1">An</option>
            <option [ngValue]="0">Aus</option>
          </select>
        </div>

        <!-- Zeittyp -->
        <div class="tsn-field">
          <label>Zeittyp</label>
          <div class="tsn-seg">
            <button type="button" [class.active]="!draft.oneTime" (click)="draft.oneTime=false">Wiederkehrend</button>
            <button type="button" [class.active]="draft.oneTime" (click)="draft.oneTime=true">Einmalig</button>
          </div>
        </div>

        <!-- Wiederkehrend -->
        <div class="tsn-field tsn-field-full" *ngIf="!draft.oneTime">
          <label>Wochentage</label>
          <div class="tsn-dow">
            <button *ngFor="let d of weekdayLabels; let i=index" type="button"
              [class.active]="draft.weekdays[i]" (click)="toggleWeekday(i)">{{ d }}</button>
          </div>
        </div>
        <div class="tsn-field" *ngIf="!draft.oneTime">
          <label>Uhrzeit</label>
          <div class="tsn-time-row">
            <input type="time" class="form-control form-control-sm rounded-0" [(ngModel)]="draft.onTime">
            <span class="text-secondary">bis</span>
            <input type="time" class="form-control form-control-sm rounded-0" [(ngModel)]="draft.offTime">
          </div>
        </div>

        <!-- Einmalig -->
        <div class="tsn-field" *ngIf="draft.oneTime">
          <label>Von</label>
          <div class="tsn-time-row">
            <input type="date" class="form-control form-control-sm rounded-0" [(ngModel)]="draft.startDate">
            <input type="time" class="form-control form-control-sm rounded-0" [(ngModel)]="draft.startTime">
          </div>
        </div>
        <div class="tsn-field" *ngIf="draft.oneTime">
          <label>Bis</label>
          <div class="tsn-time-row">
            <input type="date" class="form-control form-control-sm rounded-0" [(ngModel)]="draft.endDate">
            <input type="time" class="form-control form-control-sm rounded-0" [(ngModel)]="draft.endTime">
          </div>
        </div>

        <!-- AQ Blinker-Kopplung -->
        <div class="tsn-field tsn-field-full" *ngIf="draft.component==='aq' && draft.id===undefined">
          <label class="tsn-check">
            <input type="checkbox" [(ngModel)]="draft.coupleBlinker">
            Blinker automatisch mitschalten (gleiche Zeit &amp; Wochentage)
          </label>
        </div>
      </div>

      <div class="tsn-editor-actions">
        <button type="button" class="btn btn-sm btn-outline-secondary rounded-0" (click)="closeEditor()">Abbrechen</button>
        <button type="button" class="btn btn-sm btn-danger rounded-0" (click)="saveSwitchPoint()">Speichern</button>
      </div>

      <!-- Stellbild-Picker -->
      <div class="tsn-sb-overlay" *ngIf="sbPickerOpen">
        <div class="tsn-sb-modal">
          <div class="tsn-sb-modal-head">
            <span>Stellbild auswählen</span>
            <button type="button" class="btn btn-sm btn-link p-0" (click)="sbPickerOpen=false" aria-label="Schließen">✕</button>
          </div>
          <div class="tsn-sb-grid">
            <button *ngFor="let o of stellbildOptions" type="button" class="tsn-sb-cell"
              [class.sel]="o.stellcode===draft.tlS_Code" (click)="selectStellbild(o)">
              <img *ngIf="o.path" [src]="o.path" alt="Stellbild">
              <span class="mono">Code {{ o.stellcode }}</span>
            </button>
            <p *ngIf="stellbildOptions.length===0" class="text-secondary small m-2">Keine Stellbilder im Projekt geladen.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Zugewiesene Stationen + Zuweisen-Dialog (ausgelagerte Sub-Komponente) -->
    <avs-time-switch-assignment-panel
      [timer]="selectedTimer"
      [projectStations]="projectStations"
      [projectGroups]="projectGroupsList"
      [metaByGroup]="metaByGroup">
    </avs-time-switch-assignment-panel>
  </section>
</div>

<!-- Kombinierte Hover-Vorschau: Stellbild (Originalgröße) + Text -->
<div class="tsn-preview" *ngIf="hoverText" [style.left.px]="hoverX" [style.top.px]="hoverY">
  <img *ngIf="hoverImage" [src]="hoverImage" [class.tsn-stellbild-off]="hoverOff" alt="Stellbild Originalgröße">
  <div class="tsn-preview-text">{{ hoverText }}</div>
</div>

<ng-template #noSelection>
  <section class="tsn-detail">
    <div class="tsn-panel tsn-placeholder text-secondary">
      Wählen Sie links eine Zeitschaltuhr oder legen Sie eine neue an.
    </div>
  </section>
</ng-template>

<ng-template #noProject>
  <p class="mt-3 fw-semibold text-secondary">Kein Projekt ausgewählt!</p>
</ng-template>
